import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Login } from "./routes/Login.js";
import { Connect } from "./routes/Connect.js";
import { Device } from "./routes/Device.js";
import { ForgotPassword } from "./routes/ForgotPassword.js";
import { ResetPassword } from "./routes/ResetPassword.js";
import { AcknowledgeActionItem } from "./routes/AcknowledgeActionItem.js";
import { AcceptHubInvite } from "./routes/AcceptHubInvite.js";
import { AcceptTenantInvite } from "./routes/AcceptTenantInvite.js";
import { NotFound } from "./routes/NotFound.js";
import { AdminHome } from "./routes/AdminHome.js";
import { TenantApp } from "./routes/TenantApp.js";
import { setUnauthorizedHandler } from "./lib/api.js";

export function App() {
  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    setUnauthorizedHandler((loginPath) => nav(loginPath, { replace: true }));
    return () => setUnauthorizedHandler(null);
  }, [nav]);

  const isShellRoute =
    location.pathname === "/admin" ||
    location.pathname.startsWith("/admin/") ||
    location.pathname === "/app" ||
    location.pathname.startsWith("/app/");

  return (
    <div className={isShellRoute ? "page pageWide" : "page"}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/device" element={<Device />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/ack" element={<AcknowledgeActionItem />} />
        <Route path="/admin/login" element={<Navigate to={{ pathname: "/login", search: location.search }} replace />} />
        <Route path="/admin/accept-invite" element={<AcceptHubInvite />} />
        <Route path="/admin/*" element={<AdminHome />} />
        <Route path="/app/accept-invite" element={<AcceptTenantInvite />} />
        <Route path="/app/*" element={<TenantApp />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

